import React, { Fragment } from 'react';
import { BackButton } from 'components/header/navigation-bar/mobile-menu/fragments/back-button';
import { connect } from 'react-redux';
import { map } from 'lodash-es';
import { helpMenuSelector } from 'common/selectors';
import { SUB_MENU_TYPES } from 'components/header/navigation-bar/mobile-menu';

export const HelpMenuFragment = connect(
  (state) => ({
    helpMenu: helpMenuSelector(state),
  }),
  {}
)(({ showHideSubMenu, showHideMobileMenu, helpMenu }) => (
  <Fragment>
    <BackButton onClick={showHideSubMenu.bind(this, SUB_MENU_TYPES.HELP)} />
    <ul className="ct-mobile-menu__list ct-mobile-menu__list--language-change-menu">
      {map(helpMenu, (item, key) => {
        return (
          <li
            key={key}
            className={`ct-mobile-menu__list-elem`}
            onClick={() => {
              showHideMobileMenu();
              showHideSubMenu(SUB_MENU_TYPES.HELP);
              window.scrollTo(0, 0);
            }}
          >
            <a
              href={item.url.indexOf('//') === -1 ? `//${item.url}` : item.url}
              target={'_blank'}
              rel="noopener noreferrer"
            >
              {item.label}
            </a>
          </li>
        );
      })}
    </ul>
  </Fragment>
));
